import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeInOut } from 'src/app/shared/services/app.animation';
import { UserAgentService } from '../../services/user-agent.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { HttpService } from 'src/app/shared/services/httpService.service';
import { NotificationsEmailTempService } from '../../services/notification-template-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notification-email-tem',
  templateUrl: './notification-email-tem.component.html',
  styleUrls: ['./notification-email-tem.component.scss'],
  animations:[fadeInOut]
})
export class NotificationEmailTemComponent {
  public pageDropdownMenu: any = [10, 20, 30];
  public itemsPerPage: number = 10;
  public totalItems: number;
  currentPage: number = 1; 
  totalPages: number = 1;
  userList: any;
  public first_page_url: any = "";
  public last_page_url: any = "";
  initials:any
  public next_page_url: any = "";
  totalusers:number
  tagForm:FormGroup;
  modalRef:any
  tagId:any
  showmodal:boolean = false
  tagTypeList:any
isSkeletonLoader: boolean=true;
  constructor(private fb:FormBuilder,private userAgentService:UserAgentService,private _snackBar:MatSnackBar,
    private router:Router,private http:HttpService,private commonService:CommonService,private modalService: NgbModal,private notifationTempService:NotificationsEmailTempService){}
    @ViewChild('tagModal') tagModal;

    ngOnInit(): void {
      this.tagForm = this.fb.group({
        tagName: ['', Validators.required],
        tagTypeId:[1,Validators.required],
        isActive: [1, Validators.required]
      });
      this.getUserList()
      this.getTagType()
    }

    getTagType(search?){
      let itemsPerPage = this.itemsPerPage;
      let obj={
        "per_page": itemsPerPage,
        "page": this.currentPage,
      }
      this.userAgentService.getTagTypeList(search,obj).subscribe((res:any)=>{
        this.tagTypeList=res?.data?.data;
      })
    }
  getUserList(search?){
    let itemsPerPage = this.itemsPerPage;
    let obj={
      "per_page": itemsPerPage,
      "page": this.currentPage,
    }
    this.notifationTempService.getTemplateList(search,obj).subscribe((res:any)=>{
      this.userList=res?.data?.data;
      this.totalusers=res?.data?.total
      this.totalItems = res.data.total
      this.currentPage = res.data.current_page
      this.first_page_url = res.data.first_page_url
      this.last_page_url = res.data.last_page_url
      this.next_page_url = res.data.next_page_url
    })
    setTimeout(()=>{
      this.isSkeletonLoader=false
    },1500)
    // this.loadUser=false
  }
  onChangeNumberOfPage() {
    this.getUserList()
  }
  pageChange(event) {
    this.currentPage = event
    this.getUserList()
  }
  editRouter(user:any){
    this.router.navigate(['/user-settings/create-email-template'], { queryParams: { id: user.id} });

  }
  back(){
    this.router.navigateByUrl(`/user-settings`)
  }
  filterdData(event:any){
    let data=event.target.value
    this.getUserList(data);
    // console.log('getUser data: ',this.getUserList(data))
  }

  deleteTag(id: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won’t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.notifationTempService.DeleteTemplate(id).subscribe(
          (res: any) => {
            if (res.Status) {
              this.commonService.showToast('success', 'Success', res.data);
              this.getUserList();
            } else {
              this.commonService.showToast('error', 'Error', 'Something went wrong');
            }
          },
          (error) => {
            this.commonService.showToast('error', 'Error', 'Failed to delete resource');
            console.error('API error:', error);
          }
        );
      }
    });
  }
  duplicateTemplate(id: number): void {
    Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to create a duplicate of this email template?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, duplicate it!'
    }).then((result) => {
        if (result.isConfirmed) {
            this.notifationTempService.getShowEditData(id).subscribe((res: any) => {
                const data = res?.data;

                if (!data) {
                    this.commonService.showToast('error', 'Error', 'Failed to fetch template data.');
                    return;
                }

                // Modify template name and identifier for duplication
                const duplicatedTemplateName = `${data.template_name} (Copy)`;
                const duplicatedTemplateIdentifier = duplicatedTemplateName.toUpperCase().replace(/ /g, '_');

                // Prepare the duplicated payload
                const duplicatePayload = {
                    templateName: duplicatedTemplateName,
                    templateTypeId: data.template_type_id,
                    templateIdentifier: duplicatedTemplateIdentifier,
                    tags: data.tags.map((tag: any) => tag.tag_name),
                    content: {
                        subject: data.content?.subject || '',
                        bodyHTML: data.content?.body_html || '',
                        bodyPlainText: data.content?.body_plain_text || ''
                    },
                    placeholders: data.placeholders || []
                };

                // Send the duplicated data to the API
                this.notifationTempService.storeTempalateData(duplicatePayload).subscribe(
                    (response: any) => {
                        if (response.Status) {
                            this.commonService.showToast('success', 'Success', 'Duplicate template created successfully!');
                        } else {
                            this.commonService.showToast('error', 'Error', 'Failed to create duplicate template.');
                        }
                    },
                    (error) => {
                        this.commonService.showToast('error', 'Error', error.error);
                        console.error('API error:', error);
                    }
                );
            });
        }
    });
}
showTemplatePopup(id: number): void {
  this.notifationTempService.getShowEditData(id).subscribe((res: any) => {
      const data = res?.data;

      if (!data) {
          this.commonService.showToast('error', 'Error', 'Failed to fetch template data.');
          return;
      }

      // Extract template details
      const templateName = data.template_name || 'N/A';
      const subject = data.content?.subject || 'No Subject';
      const bodyHTML = data.content?.body_html || data.content?.body_plain_text;

      // Construct the popup HTML
      const popupHTML = `
          <div style="font-family: Arial, sans-serif; text-align: left;">
              <h3 style="font-size: 18px; font-weight: bold; margin-bottom: 5px;">Template Preview</h3>
      
              <hr style="border: none; border-top: 1px solid #ddd; margin: 10px 0;">
              
              <p style="font-size: 14px;"><strong>To:</strong> Example Contact &lt;example@google.com&gt;</p>
              <p style="font-size: 14px;"><strong>Subject:</strong> <span style="color: #d9534f;">${subject}</span></p>

              <div style="border: 1px solid #ddd; padding: 15px; background: #f9f9f9; border-radius: 5px; margin-top: 10px;">
                  ${bodyHTML}
              </div>
          </div>
      `;

      // Show the SweetAlert popup
      Swal.fire({
          html: popupHTML,
          width: '600px',
          showCloseButton: true,
          showConfirmButton: false
      });
  });
}

highlightCopy(name: string | null): string {
  if (!name) return '';
  return name.replace(/\(Copy\)/gi, '<span style="color: red; font-weight: bold;">(Copy)</span>');
}


  
}
